import { css } from '@emotion/react'
import { Heading, Icon, Table, TableBody, TableCell, TableRow, Text, VFlow } from 'bold-ui'
import { blue, gray } from 'bold-ui/lib/styles/colors'
import { useFlags } from 'config/useFlagsContext'
import { ReactComponent as SignatureIcon } from 'images/atendimento/assinador/icon-signature.svg'
import { ReactComponent as Consulta } from 'images/historico/icone-consulta.svg'
import { ReactComponent as PreNatalIcon } from 'images/historico/icone-pre-natal.svg'
import { ReactComponent as PuerperioIcon } from 'images/historico/icone-puerperio.svg'
import { ReactComponent as AcompanhamentoCondicoesDeSaudeIcon } from 'images/side-menu/acompanhamentos.svg'
import { ReactComponent as AssinaturaEletronicaIcon } from 'images/side-menu/assinatura-eletronica.svg'
import { ReactComponent as AtividadeColetivaIcon } from 'images/side-menu/atividade-coletiva.svg'
import { ReactComponent as CidadaoIcon } from 'images/side-menu/cidadao.svg'
import { ReactComponent as GarantiaAcessoIcon } from 'images/side-menu/garantia-acesso.svg'
import { ReactComponent as IntegracaoIcon } from 'images/side-menu/integracao.svg'
import { ReactComponent as Relatorios } from 'images/side-menu/relatorios.svg'
import { ReactComponent as VideochamadaIcon } from 'images/side-menu/videochamadas.svg'
import { ReactComponent as SdcIcon } from 'images/suporte-decisao-clinica/health-system-outline.svg'
import { Fragment } from 'react'

import PuericulturaIcon from '../../../images/soap/ic_puericultura.webp'
import { Carousel, CarouselItem } from '../components/Carousel'
import { ExpandableText } from '../components/ExpandableText'
import { NewsGif } from '../components/NewsGif'
import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsImg } from '../components/NewsImg'
import { NewsList } from '../components/NewsList'
import { NewsListItem } from '../components/NewsListItem'
import { NewsParagraph } from '../components/NewsParagraph'
import { NewsSectionContent } from '../components/NewsSectionContent'

export function NewsInternalPanelCincoCinco() {
  const {
    RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED,
    PILOTO_PRONTUARIO_FAMILIAR_ENABLED,
    PILOTO_SDC_PRE_ECLAMPSIA_ENABLED,
    PILOTO_RNDS_REPM_ENABLED,
    PILOTO_SDC_RISCO_CARDIOVASCULAR_ENABLED,
    PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED,
    PILOTO_VINCULACAO_CUIDADO_ENABLED,
    PILOTO_INTEGRACAO_REGULACAO_ENABLED,
    PILOTO_ASSINADOR_REPM_ENABLED,
    PILOTO_ATENDIMENTO_SOCIOEDUCATIVO_ENABLED,
    PILOTO_SDC_RISCO_CARDIOVASCULAR_SEGUNDA_ENTREGA_ENABLED,
    PILOTO_EXAMES_SAUDE_MULHER_ENABLED,
    PILOTO_M_CHAT_RF_ENABLED,
    PILOTO_GRAFICOS_PRE_TERMO_ENABLED,
    PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED,
    PILOTO_INATIVACAO_IMOVEIS_ENABLED,
    PILOTO_GRUPOS_ATIVIDADE_COLETIVA_ENABLED,
    PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED,
    MOTIVO_PRESCRICAO_ENABLED,
    PILOTO_SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED,
    SOLICITACAO_EXAME_MAMOGRAFIA_ENABLED,
    PILOTO_CID11_ENABLED,
    HORARIO_FINAL_AGENDAMENTO_ENABLED,
    PILOTO_VINCULACAO_CUIDADO_ODONTO_ENABLED,
    HISTORICO_COMPLETO_MCHAT_RF_ENABLED,
    GESTAO_DOCUMENTO_CIDADAO_ENABLED,
    PILOTO_PARTICIPACAO_OBRIGATORIA_TELECONSULTA_ENABLED,
    ASSINATURA_ELETRONICA_ENABLED,
    ACOMPANHAMENTO_CONDICAO_SAUDE_MARTS_ENABLED,
    NOVA_IMPRESSAO_PRE_NATAL_ENABLED,
    ERRATAS_NOTAS_COMPLEMENTARES_ENABLED,
  } = useFlags()

  const listaCidsCardiovascular =
    'I11, I11.0, I11.9, I12, I12.0, I12.9, I13, I13.0, I13.1, I13.2, I13.9, I15.0, I15.1, I20, I20.0, I20.1, I20.8, I20.9, I21, I21.0, I21.1, I21.2, I21.3, I21.4, I21.9, I22, I22.0, I22.1, I22.8, I22.9, I23, I23.0, I23.1, I23.2, I23.3, I23.4, I23.5, I23.6, I23.8, I24, I24.0, I24.8, I24.9, I25, I25.0, I25.1, I25.2, I25.3, I25.4, I25.5, I25.6, I25.8, I25.9, I42.9, I50, I50.0, I50.1, I50.9, I51.6, I60, I60.0, I60.1, I60.2, I60.3, I60.4, I60.5, I60.6, I60.7, I60.8, I60.9, I61, I61.0, I61.1, I61.2, I61.3, I61.4, I61.5, I61.6, I61.8, I61.9, I63, I63.0, I63.1, I63.2, I63.3, I63.4, I63.5, I63.8, I63.9, I64, I65, I65.0, I65.1, I65.2, I65.3, I65.8, I65.9, I66, I66.0, I66.1, I66.2, I66.3, I66.4, I66.8, I66.9, I67, I67.0, I67.1, I67.2, I67.3, I67.4, I67.7, I67.8, I67.9, I69, I69.0, I69.1, I69.2, I69.3, I69.4, I70, I70.0, I70.1, I70.2, I70.8, I70.9, I71, I71.0, I71.1, I71.2, I71.3, I71.4, I71.5, I71.6, I71.8, I71.9, I72, I72.0, I72.1, I72.2, I72.3, I72.4, I72.8, I72.9, I74, I74.0, I74.1, I74.2, I74.3, I74.4, I74.5, I74.8, I74.9, I79.0 ou O11'

  const listaCidsDiabetesMellitus =
    'E10, E10.0, E10.1, E10.2, E10.3, E10.4, E10.5, E10.6, E10.7, E10.8, E10.9, E11, E11.0, E11.1, E11.2, E11.3, E11.4, E11.5, E11.6, E11.7, E11.8, E11.9, E12, E12.0, E12.1, E12.2, E12.3, E12.4, E12.5, E12.6, E12.7, E12.8, E12.9, E13, E13.0, E13.1, E13.2, E13.3, E13.4, E13.5, E13.6, E13.7, E13.8, E13.9, E14, E14.0, E14.1, E14.2, E14.3, E14.4, E14.5, E14.6, E14.7, E14.8, E14.9, O24.0, O24.1, O24.2 ou O24.3'

  return (
    <Fragment>
      {ACOMPANHAMENTO_CONDICAO_SAUDE_MARTS_ENABLED && (
        <NewsHeadingSection
          title='Melhorias no Acompanhamento de Condições de Saúde e Busca Ativa de Vacinação'
          icon={<AcompanhamentoCondicoesDeSaudeIcon css={styles.iconSVG} />}
          id='melhorias-acompanhamento-condicoes-saude-busca-ativa-vacinacao-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              Pensando em oferecer uma visão mais completa e fiel à realidade dos cidadãos acompanhados pelas equipes de
              saúde, a forma como os dados são consolidados nas listas temáticas passou por uma importante atualização.
            </NewsParagraph>
            <Heading level={4}>Integração total de dados (todas as origens)</Heading>
            <NewsParagraph>
              Anteriormente, a maior parte das informações exibia apenas registros vindos do prontuário (SOAP). Agora,
              as listas temáticas passam a considerar <strong>dados de todas as origens de registro</strong>:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>Atendimentos e registros do Prontuário (SOAP e CDS);</NewsListItem>
              <NewsListItem>Aplicativos (APPs);</NewsListItem>
              <NewsListItem>Importações via modelo LEDI e migrações entre instalações do e-SUS APS.</NewsListItem>
            </NewsList>
            <Heading level={4}>Critérios das Listas Temáticas</Heading>
            <NewsParagraph>
              Cada lista temática aplica regras pré-definidas de inclusão com base em boas práticas em saúde.
            </NewsParagraph>
            <NewsParagraph>
              <strong>Atenção:</strong> por padrão, todas as listas consideram apenas pessoas com atendimento individual
              nos últimos 3 anos (o filtro de período do último atendimento pode ser removido pelo usuário para incluir
              pessoas independentemente dessa data).
            </NewsParagraph>
            <Heading level={4}>Lista Geral</Heading>
            <NewsParagraph>
              Lista-base da qual todas as demais derivam. Apresenta todas as pessoas com vínculo ativo e mais recente à
              equipe. Toda pessoa em uma lista temática estará na Geral, mas nem toda pessoa da Geral estará nas
              temáticas específicas.
            </NewsParagraph>
            <Heading level={4}>Gestação e Puerpério</Heading>
            <NewsParagraph>
              Apresenta pessoas com gestação ativa registrada no SOAP ou cujo término da gestação ocorreu há até 42 dias
              (período puerperal).
            </NewsParagraph>
            <Heading level={4}>Pessoa Idosa</Heading>
            <NewsParagraph>Apresenta pessoas com 60 anos ou mais na data atual.</NewsParagraph>
            <Heading level={4}>Desenvolvimento Infantil</Heading>
            <NewsParagraph>Apresenta crianças com menos de 5 anos completos (0 a 4 anos) na data atual.</NewsParagraph>
            <Heading level={4}>Diabetes e Hipertensão</Heading>
            <NewsParagraph>
              Apresentam pessoas com diagnóstico ativo no SOAP. É possível utilizar o filtro "Não incluídos na lista de
              problemas e condições" para incluir pessoas que já tiveram o diagnóstico no passado, mas não possuem a
              condição ativa no momento.
            </NewsParagraph>
            <Heading level={4}>Saúde da Mulher</Heading>
            <NewsParagraph>
              Apresenta pessoas de 14 a 69 anos com sexo registrado como Feminino ou Indeterminado.
            </NewsParagraph>
            <NewsParagraph>
              <strong>Atenção:</strong> pessoas com sexo feminino e identidade de gênero "Mulher transgênero" não são
              incluídas nesta lista. É possível optar por incluir pessoas com sexo masculino cuja identidade de gênero
              seja "Homem transgênero".
            </NewsParagraph>
            <Heading level={4}>Saúde Bucal</Heading>
            <NewsParagraph>
              Apresenta as pessoas da lista padrão que possuem ao menos um atendimento odontológico individual
              registrado no Prontuário.
            </NewsParagraph>
            <Heading level={4}>Informações importantes</Heading>
            <NewsList>
              <NewsListItem>
                <strong>Atuação dos Filtros Personalizados:</strong> os filtros disponíveis permitem ajustar os
                resultados conforme a necessidade da equipe, porém eles estão limitados aos critérios de inclusão
                específicos de cada lista temática (algumas regras de elegibilidade da lista não podem ser alteradas).
              </NewsListItem>
              <NewsListItem>
                <strong>Processamento Diário:</strong> as listas são reprocessadas diariamente durante a noite. Dados e
                alterações inseridos no prontuário no dia de hoje serão refletidos nas listas a partir do dia seguinte
                ou após a geração manual dos lotes.
              </NewsListItem>
            </NewsList>
            <Heading level={4}>Busca Ativa de Vacinação</Heading>
            <NewsParagraph>
              Quando utilizado o Grupo-alvo de Gestantes/Puérperas, as pessoas exibidas estarão limitadas às mesmas
              pessoas exibidas na lista temática de Gestação e Puerpério.
            </NewsParagraph>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {ASSINATURA_ELETRONICA_ENABLED && (
        <NewsHeadingSection
          title='Assinatura digital de atendimentos'
          icon={<AssinaturaEletronicaIcon css={styles.iconSVG} />}
          id='assinatura-digital-atendimentos-5-5'
        >
          <NewsSectionContent>
            <NewsListItem>
              Agora o profissional pode <strong>assinar digitalmente</strong> os documentos referentes aos seus{' '}
              <strong>atendimentos</strong> finalizados.
            </NewsListItem>
            <NewsListItem>
              A assinatura dos atendimentos pode ser gerenciada através do{' '}
              <strong>módulo "Assinatura digital de documentos"</strong>, onde é possível realizar a assinatura digital
              do registro:
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_assinar_documento.gif'
              pausedSrc='/static/novidades/5-5_assinar_documento_paused.webp'
              alt='Gif mostrando a assinatura digital de um registro de atendimento pelo módulo Assinatura digital de documentos'
              width={1902}
              height={941}
            />
            <NewsListItem>
              Além disso, o profissional pode também visualizar o registro do atendimento e <strong>baixar</strong> o{' '}
              <strong>documento assinado</strong>:
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_baixar_visualizar_documento_assinado.gif'
              pausedSrc='/static/novidades/5-5_baixar_visualizar_documento_assinado_paused.webp'
              alt='Gif mostrando a visualização do registro do atendimento e o download do documento assinado'
              width={1902}
              height={941}
            />
            <NewsListItem>
              Para ativar a funcionalidade, o <strong>administrador da instalação</strong> deve ter a{' '}
              <strong>Assinatura digital</strong> habilitada e habilitar a <strong>Assinatura de registros</strong>.
            </NewsListItem>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {GESTAO_DOCUMENTO_CIDADAO_ENABLED && (
        <NewsHeadingSection
          title='Gerenciamento de CNS no cadastro individual'
          icon={<CidadaoIcon />}
          id='gerenciamento-multiplos-cns-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              O Cadastro individual agora permite identificar todos os números de CNS associados a um cidadão na base
              local e remover os equivocados, como nos casos em que uma unificação de prontuários juntou, por engano, os
              registros de duas pessoas diferentes.
            </Text>
            <Text fontSize={0.875} component='p'>
              Diretamente na visualização ou atualização do cadastro, você pode ver todos os CNS vinculados ao cidadão e
              sua origem (unificação de prontuários, base nacional ou atualização por ficha CDS). Quando identificar um
              CNS incompatível, o usuário com a permissão adequada pode abrir a opção "Gerenciar documentos" na
              atualização do cadastro e removê-lo do cadastro, permitindo que um novo cadastro e prontuário sejam
              criados com esse número dali em diante.
            </Text>
            <Text fontSize={0.875} component='p'>
              Vale lembrar que uma pessoa ter mais de um CNS é normal e não é, por si só, um problema — muitos cidadãos
              possuem números provisórios além do definitivo. A remoção é indicada apenas quando um dos CNS listados
              pertencer, de fato, a outra pessoa. Essa ação não afeta atendimentos e registros clínicos já salvos, que
              permanecem no prontuário atual — por isso, ela precisa ser realizada com cautela.
            </Text>
            <NewsGif
              src='/static/novidades/5-5_gerenciamento_multiplos_cns.gif'
              pausedSrc='/static/novidades/5-5_gerenciamento_multiplos_cns_paused.webp'
              alt='Gif mostrando o gerenciamento de múltiplos CNS no cadastro individual'
              width={1081}
              height={774}
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection title='Atualização da base de endereços' id='atualizacao-base-enderecos-5-5'>
        <NewsSectionContent>
          <NewsParagraph>
            A base de endereços do sistema foi atualizada, mantendo os dados de localidades em conformidade com a versão
            de 2026.
          </NewsParagraph>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection
        title='Suporte ao novo CNPJ Alfanumérico'
        icon={<IntegracaoIcon css={styles.iconSVG} />}
        id='cnpj-alfanumerico-5-5'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Para atender à nova regulamentação da Receita Federal (Instrução Normativa nº 2.229), o prontuário e-SUS APS
            foi atualizado para suportar o CNPJ alfanumérico. Agora, o formato do CNPJ continua com 14 dígitos, porém os
            12 primeiros caracteres podem variar entre letras e números, mantendo apenas os 2 últimos caracteres como
            dígitos verificadores numéricos.
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-5_cnpj_alfanumerico.webp'
            alt='Imagem exibindo o novo formato de CNPJ Alfanumérico'
            width={676}
            height={246}
          />
          <NewsParagraph>
            Essa atualização foi realizada para garantir que o sistema continue funcionando corretamente com a nova
            regra, evitando falhas no reconhecimento do CNPJ e garantindo a integridade dos dados.
          </NewsParagraph>
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_CID11_ENABLED && (
        <NewsHeadingSection
          title='Inclusão do campo de CID-11 na Avaliação do SOAP e na Lista de problemas/condições'
          icon={<Consulta css={styles.iconSVG} />}
          id='cid11-problemas-condicoes-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              O PEC foi atualizado com a inclusão do campo de CID-11, a 11ª revisão da Classificação Internacional de
              Doenças, trazendo novos códigos para registro e classificação de condições de saúde.
            </NewsParagraph>
            <NewsParagraph>
              Agora, a Avaliação e a Lista de problemas/condições do SOAP contam com um campo de CID-11 complementar à
              CID-10. Ao informar um código no campo de CID-10, o campo de CID-11 exibe códigos correspondentes ao
              código informado. Além disso, a CID-11 registrada também pode ser incluída na Lista de
              problemas/condições.
            </NewsParagraph>
            <NewsParagraph>
              Neste momento, a CID-11 não substitui a CID-10: seu preenchimento é complementar, opcional e tem caráter
              informativo, apoiando a transição gradual para o novo padrão de classificação.
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_cid11_problemas_condicoes_A.webp'
                alt='Imagem exibindo o campo de CID-11 na Lista de problemas/condições'
                width={1286}
                height={547}
              />
              <CarouselItem
                image='/static/novidades/5-5_cid11_problemas_condicoes_B.webp'
                alt='Imagem exibindo o campo de CID-11 na Lista de problemas/condições com opções de CID-11'
                width={1282}
                height={648}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Novos itens nos campos do registro de Atividade coletiva'
        icon={<AtividadeColetivaIcon css={styles.iconSVG} />}
        id='novos-temas-public-alvo-ac-5-5'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Agora no registro de Atividade Coletiva é possível informar o tema <strong>Vigilância em saúde</strong> para
            atividades em reunião e os públicos-alvo{' '}
            <strong>Adolescente em atendimento socioeducativo em meio aberto</strong> e{' '}
            <strong>Adolescente em atendimento socioeducativo em meio fechado</strong> em atividades em saúde.
          </NewsParagraph>
          <NewsParagraph>
            Os novos itens também estão disponíveis no relatório de produção de Atividade Coletiva e em seus filtros
            personalizados.
          </NewsParagraph>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-5_ac_novo_tema_reuniao.png'
              alt='Imagem exibindo novo tema para reunião em Vigilância em saúde na AC'
              width={973}
              height={567}
            />
            <CarouselItem
              image='/static/novidades/5-5_ac_novos_publicos-alvo.png'
              alt='Imagem exibindo novo público-alvo de Adolescentes em meio aberto/fechado na AC'
              width={992}
              height={651}
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Atualização SIGTAP' id='sigtap-5-5'>
        <NewsSectionContent>
          <NewsListItem>
            Atualização da tabela de procedimentos SIGTAP para a competência de 05/2026, trazendo inclusões e alterações
            de procedimentos.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection
        title='Novo modelo de atestado para Solicitação de fraldas geriátricas'
        icon={<Consulta css={styles.iconSVG} />}
        id='solicitacao-fraldas-geriatricas-5-5'
      >
        <NewsSectionContent>
          <NewsParagraph>
            O módulo de Atestados passa a contar com um novo modelo destinado à{' '}
            <strong>Solicitação de fraldas geriátricas</strong>, desenvolvido com o objetivo de padronizar e simplificar
            o preenchimento das informações relacionadas à concessão do insumo.
          </NewsParagraph>
          <NewsParagraph>O novo modelo contempla os seguintes campos:</NewsParagraph>
          <NewsList>
            <NewsListItem>Tamanho da fralda (P, M, G, GG e XG);</NewsListItem>
            <NewsListItem>Recomendação diária;</NewsListItem>
            <NewsListItem>
              Total de unidades, correspondente à quantidade mensal de fraldas, calculada automaticamente com base na
              recomendação diária informada;
            </NewsListItem>
            <NewsListItem>CID-10, com preenchimento opcional.</NewsListItem>
          </NewsList>
          <NewsParagraph>
            A iniciativa busca proporcionar maior clareza e agilidade no preenchimento do atestado, além de promover
            maior consistência das informações registradas e apoiar a emissão do documento pelas equipes de saúde.
          </NewsParagraph>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-5_solicitacao_fraldas_geriatricas_A.png'
              alt='Imagem exibindo solicitação de fraldas geriátricas'
              width={1150}
              height={482}
            />
            <CarouselItem
              image='/static/novidades/5-5_solicitacao_fraldas_geriatricas_B.png'
              alt='Imagem exibindo solicitação de fraldas geriátricas com CID-10'
              width={1150}
              height={483}
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Inativação de procedimentos AB no sistema' id='inativacao-procedimentos-ab-5-5'>
        <NewsSectionContent>
          <NewsListItem>
            Os procedimentos classificados como do tipo <strong>AB</strong> que possuíam equivalência na tabela{' '}
            <strong>SIGTAP</strong> foram inativados no sistema, permanecendo disponíveis para seleção apenas aqueles
            vinculados à tabela <strong>SIGTAP</strong>.
          </NewsListItem>
          <NewsListItem>
            A alteração contempla tanto o CDS quanto os módulos do PEC e foi realizada com o objetivo de promover a
            padronização das terminologias utilizadas no sistema, garantindo maior consistência e alinhamento com os
            padrões de SIGTAP.
          </NewsListItem>
          <NewsListItem>
            Além disso, a iniciativa busca reduzir inconsistências operacionais e evitar conflitos gerados por
            duplicidades de procedimentos existentes entre as tabelas, contribuindo para uma melhor integridade dos
            registros, maior rastreabilidade das informações e simplificação do processo de seleção e manutenção dos
            procedimentos na aplicação.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_RNDS_REPM_ENABLED && (
        <NewsHeadingSection
          title='RNDS - Registro Eletrônico de Prescrição de Medicamentos (REPM)'
          icon={<Icon icon='medicineBottleFilled' css={css(styles.iconSVG, styles.fillableIconSVG)} />}
          id='rnds-repm-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              O e-SUS APS passa a enviar os registros de prescrição para a RNDS nos formatos Registro de Prescrição de
              Medicamento (RPM) ou Registro Eletrônico de Prescrição de Medicamento (REPM).
            </NewsParagraph>
            <NewsParagraph>A escolha do formato é determinada pela classificação do medicamento:</NewsParagraph>
            <NewsList>
              <NewsListItem>
                REPM: Utilizado para medicamentos cujo código CATMAT possui código correspondente na OBM;
              </NewsListItem>
              <NewsListItem>
                RPM: Utilizado para medicamentos cujo código CATMAT não possui correspondência de código na OBM.
              </NewsListItem>
            </NewsList>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection title='Evolução do Módulo do Cidadão' id='novo-cidadao-5-5' icon={<CidadaoIcon />}>
        <NewsSectionContent>
          <NewsParagraph>
            O Módulo do Cidadão evoluiu e agora se chama Cadastro individual! Ele passa a centralizar a gestão dos
            cadastros, gerando fichas automáticas conforme necessário. As principais mudanças nesse módulo incluem:
          </NewsParagraph>
          <NewsList>
            <NewsListItem>
              Não há mais necessidade de utilizar a antiga Ficha de Cadastro Individual, pois as informações que antes
              eram registradas nela agora foram integradas ao módulo do Cadastro individual.
            </NewsListItem>
            <NewsListItem>
              Integração com o Acompanhamento do território: mudanças no módulo do Cadastro individual refletem na
              composição familiar e vinculação do território.
            </NewsListItem>
            <NewsListItem>
              O campo CPF passa a ser obrigatório na seção de Dados Pessoais, diminuindo a possibilidade de cadastros
              duplicados.
            </NewsListItem>
            <NewsListItem>
              Os campos relacionados a Informações sociodemográficas, Informações socioeconômicas e Condições de saúde
              autorreferidas foram integrados ao módulo, permitindo maior detalhamento de informações no cadastro. Eles
              podem ser preenchidos ao abrir as suas respectivas seções expansíveis, sendo exibidos em cadastros na
              Atenção Primária à Saúde.
            </NewsListItem>
            {PILOTO_ATENDIMENTO_SOCIOEDUCATIVO_ENABLED && (
              <NewsListItem>
                O Cadastro individual passa a permitir o registro de informações relacionadas ao atendimento
                socioeducativo de adolescentes entre 12 e 21 anos, incluindo o tipo e o tempo de atendimento
                socioeducativo nas Informações sociodemográficas.
              </NewsListItem>
            )}
            <NewsListItem>
              Em cadastros e atualizações realizados na APS é possível definir, a partir de uma lotação ativa, a Equipe
              de referência vinculada ao cidadão, substituindo o antigo preenchimento de informações do profissional que
              era feito no cabeçalho da Ficha de Cadastro Individual.
            </NewsListItem>
            <NewsListItem>
              Ao digitar as informações de identificação do cidadão em um novo cadastro, o sistema automaticamente
              identifica a possibilidade de duplicação de cadastro e, se for o caso, sugere mudar para uma atualização.
            </NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-5_cadastro_individual.webm'
            pausedSrc='/static/novidades/5-5_cadastro_individual_paused.webp'
            alt='Gif mostrando o novo módulo do Cadastro individual'
            width={1050}
            height={700}
          />
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_SDC_RISCO_CARDIOVASCULAR_SEGUNDA_ENTREGA_ENABLED && (
        <NewsHeadingSection
          title='Aprimoramento do cálculo no SDC de Risco Cardiovascular'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='sdc-alerta-risco-cardiovascular-segunda-entrega-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              O Suporte à Decisão Clínica (SDC) agora conta com um cálculo de Risco Cardiovascular (RCV) ampliado,
              estruturado com base na metodologia da calculadora HEARTS adaptada. Essa atualização contempla mais
              cenários clínicos, permitindo uma determinação de risco mais assertiva, de acordo com os registros do
              prontuário do cidadão e as diretrizes estabelecidas.
            </NewsParagraph>
            <NewsParagraph>
              Além de considerar registros de Doenças Cardiovasculares, Doença Renal Crônica e Diabetes Mellitus em
              cidadãos com idade entre 40 anos e 75 anos, o sistema agora também realiza o cálculo para aqueles que não
              possuem essas condições inseridas no prontuário.
            </NewsParagraph>
            <NewsParagraph>
              Para o cálculo ampliado de Risco Cardiovascular, o sistema considera os seguintes fatores:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>Sexo</NewsListItem>
              <NewsListItem>Idade</NewsListItem>
              <NewsListItem>Tabagismo (condição registrada na Lista de Problemas e Condições)</NewsListItem>
              <NewsListItem>Pressão arterial sistólica (registrada nas últimas 24h)</NewsListItem>
              <NewsListItem>Colesterol total (registrado nos últimos 365 dias)</NewsListItem>
              <NewsListItem>
                IMC (registrado nas últimas 24h), no caso de ausência de registro de colesterol total
              </NewsListItem>
            </NewsList>
            <NewsParagraph>
              Essa melhoria amplia a cobertura do cálculo, apoiando a estratificação de risco e fortalecendo a tomada de
              decisão clínica no cuidado longitudinal do cidadão.
            </NewsParagraph>
            <NewsParagraph>
              Além disso, o card de Rastreamentos foi adaptado para também contemplar os cenários de baixo risco e
              moderado risco cardiovascular. Nesses casos, o sistema passa a apresentar alertas específicos acompanhados
              de condutas recomendadas, apoiando o profissional de saúde na orientação e no acompanhamento adequado do
              cidadão conforme o nível de risco identificado.
            </NewsParagraph>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Batimento cardíaco fetal para gestação dupla/gemelar'
        icon={<Icon icon='heartRateFilled' />}
        id='batimento-cardiaco-fetal2-5-5'
      >
        <NewsSectionContent>
          <NewsList>
            <NewsListItem>
              Inclusão de campo para informar o{' '}
              <strong>batimento cardíaco fetal para contemplar cenários de gestação dupla/gemelar</strong>.
            </NewsListItem>
            <NewsListItem>
              A nova informação é contemplada nos locais de exibição onde o batimento cardíaco fetal já é apresentado,
              como as medições da gestação, histórico e acompanhamento do pré-natal.
            </NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-5_batimento_cardiaco_fetal2.webm'
            pausedSrc='/static/novidades/5-5_batimento_cardiaco_fetal2_paused.webp'
            alt='Gif mostrando o atendimento de pré-natal com os dois campos de batimento cardíaco fetal'
            width={1122}
            height={677}
          />
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED && (
        <NewsHeadingSection title='Classificação de Vulnerabilidade Familiar' id='vulnerabilidade-familiar-5-5'>
          <NewsSectionContent>
            <NewsParagraph>
              O PEC agora oferece uma classificação automática de vulnerabilidade familiar. Essa classificação analisa
              informações provenientes do cadastro individual, do núcleo familiar, do imóvel, do registro de problemas e
              condições de saúde, com o objetivo de identificar famílias que demandam maior atenção pelas equipes. Os
              três níveis de classificação são:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>
                <strong>Vulnerabilidade Inequívoca:</strong> Quando presente alguma condição específica que já indica
                vulnerabilidade imediata, a família é classificada neste nível, com listagem de todos os indicadores
                encontrados.
              </NewsListItem>
              <NewsListItem>
                <strong>Vulnerabilidade Sugestiva:</strong> Quando há condições sugestivas de vulnerabilidade, o sistema
                calcula um escore que define o grau de risco (habitual, baixa, média ou máxima).
              </NewsListItem>
              <NewsListItem>
                <strong>Vulnerabilidade Habitual:</strong> Quando não há indicadores de vulnerabilidade presentes na
                família.
              </NewsListItem>
            </NewsList>
            <NewsParagraph>
              A classificação é exibida na Folha de Rosto, no Prontuário Familiar e na visualização do Imóvel, e em cada
              local é possível acessar a listagem completa dos indicadores encontrados, assim como uma explicação mais
              detalhada da metodologia.
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_vulnerabilidade_familiar_folha_de_rosto.webp'
                alt='Vulnerabilidade Familiar - Folha de Rosto'
                width={1323}
                height={822}
              />
              <CarouselItem
                image='/static/novidades/5-5_vulnerabilidade_familiar_prontuario_familiar.webp'
                alt='Vulnerabilidade Familiar - Prontuário Familiar'
                width={1399}
                height={845}
              />
              <CarouselItem
                image='/static/novidades/5-5_vulnerabilidade_familiar_visualizar_imovel.webp'
                alt='Vulnerabilidade Familiar - Visualizar Imóvel'
                width={1399}
                height={863}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Módulo de Acompanhamento de Pré-natal'
        icon={<PreNatalIcon />}
        id='acompanhamento-pre-natal-5-5'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Agora é possível visualizar, de forma integrada, todas as informações relacionadas ao pré-natal da gestação
            em curso. A funcionalidade organiza e centraliza os registros de consultas, exames, vacinas e outros
            procedimentos, facilitando o acompanhamento e cuidado da gestante.
          </NewsParagraph>
          <NewsParagraph>Visualize de forma integrada todas as informações:</NewsParagraph>
          <NewsList>
            <NewsListItem>Antecedentes obstétricos;</NewsListItem>
            <NewsListItem>Informações resumidas da gestação atual;</NewsListItem>
            <NewsListItem>Acompanhamento de vulnerabilidades;</NewsListItem>
            <NewsListItem>Medições da gestante;</NewsListItem>
            <NewsListItem>Medicamentos em uso;</NewsListItem>
            <NewsListItem>Lista de problemas e condições;</NewsListItem>
            <NewsListItem>Problemas e condições autorreferidas;</NewsListItem>
            <NewsListItem>Consultas de Pré-natal;</NewsListItem>
            <NewsListItem>Atividade coletiva;</NewsListItem>
            <NewsListItem>Vacinação;</NewsListItem>
            <NewsListItem>Exames;</NewsListItem>
            <NewsListItem>Encaminhamento;</NewsListItem>
            <NewsListItem>Visitas domiciliares;</NewsListItem>
            <NewsListItem>Próximos agendamentos.</NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-5_acompanhamento_pre_natal.webm'
            pausedSrc='/static/novidades/5-5_acompanhamento_pre_natal_paused.webp'
            alt='Gif mostrando o novo módulo de Acompanhamento de Pré-natal'
            width={1792}
            height={868}
          />
          {NOVA_IMPRESSAO_PRE_NATAL_ENABLED && (
            <Fragment>
              <NewsParagraph>
                A impressão do Acompanhamento de Pré-natal foi atualizada e agora exibe dados complementares da
                gestante, garantindo a continuidade e integralidade do cuidado.
              </NewsParagraph>
              <NewsGif
                src='/static/novidades/5-5_acompanhamento_pre_natal_impressao.webm'
                pausedSrc='/static/novidades/5-5_acompanhamento_pre_natal_impressao_paused.webp'
                alt='Gif mostrando a impressão do novo módulo de Acompanhamento de Pré-natal'
              />
            </Fragment>
          )}
          <NewsParagraph>
            O módulo foi desenvolvido para destacar as informações mais relevantes durante o pré-natal, apoiando o
            profissional na tomada de decisão de forma mais ágil, segura e centrada na pessoa.
          </NewsParagraph>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection
        title='Módulo de Acompanhamento de Puerpério'
        icon={<PuerperioIcon />}
        id='acompanhamento-puerperio-5-5'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Agora é possível visualizar, de forma integrada, todas as informações relacionadas ao puerpério em curso. A
            funcionalidade organiza e centraliza os registros de consultas, exames, vacinas e outros procedimentos,
            facilitando o acompanhamento e cuidado da puérpera.
          </NewsParagraph>
          <NewsParagraph>Visualize de forma integrada todas as informações:</NewsParagraph>
          <NewsList>
            <NewsListItem>Informações resumidas do puerpério atual;</NewsListItem>
            <NewsListItem>Acompanhamento de vulnerabilidades;</NewsListItem>
            <NewsListItem>Medições da puérpera;</NewsListItem>
            <NewsListItem>Medicamentos em uso;</NewsListItem>
            <NewsListItem>Lista de problemas e condições;</NewsListItem>
            <NewsListItem>Consultas de Puerpério;</NewsListItem>
            <NewsListItem>Visitas domiciliares;</NewsListItem>
            <NewsListItem>Atividade coletiva;</NewsListItem>
            <NewsListItem>Vacinação;</NewsListItem>
            <NewsListItem>Exames;</NewsListItem>
            <NewsListItem>Próximos agendamentos;</NewsListItem>
            <NewsListItem>Novo card de puerpério na lateral do atendimento.</NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-5_acompanhamento_puerperio.webm'
            pausedSrc='/static/novidades/5-5_acompanhamento_puerperio_paused.webp'
            alt='Gif mostrando o novo módulo de Acompanhamento de Puerpério'
            width={1806}
            height={870}
          />
          <NewsParagraph>
            O módulo foi desenvolvido para destacar as informações mais relevantes durante o puerpério, apoiando o
            profissional na tomada de decisão de forma mais ágil, segura e centrada na pessoa.
          </NewsParagraph>
        </NewsSectionContent>
      </NewsHeadingSection>
      {RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED && (
        <NewsHeadingSection title='Retificação de atendimento de vacinação' id='retificacao-atendimento-vacinacao-5-5'>
          <NewsSectionContent>
            <NewsListItem>
              Foi adicionada a funcionalidade de retificar atendimentos de vacinação. Agora, o profissional que realizou
              o atendimento pode corrigir informações, incluir aplicações de imunobiológicos realizados naquele
              atendimento ou remover registros específicos inseridos de forma equivocada, sem a necessidade de excluir o
              atendimento como um todo.
            </NewsListItem>
            <NewsListItem>
              O registro retificado é inativado e as alterações realizadas podem ser visualizadas na Trilha de Auditoria
              e impressas através do histórico do cidadão.
            </NewsListItem>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_vacinacao_1.webp'
                alt='Imagem exibindo o histórico do cidadão com a retificação de vacinação'
                width={1048}
                height={591}
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_vacinacao_2.webp'
                alt='Imagem exibindo o modal de retificação de vacinação'
                width={907}
                height={690}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Sistemas externos'
        icon={<IntegracaoIcon css={styles.iconSVG} />}
        id='sistemas-externos-5-5'
      >
        <NewsSectionContent>
          <NewsListItem>
            Com o objetivo de centralizar as informações e otimizar a rotina das equipes de saúde, a nova versão do
            e-SUS APS traz a funcionalidade de sistemas externos. Agora, é possível utilizar outros sistemas diretamente
            do prontuário, eliminando a necessidade de abrir abas separadas, alternar janelas ou realizar novos logins
            durante o trabalho.
          </NewsListItem>
          <NewsListItem>
            No menu lateral e durante os atendimentos individuais e odontológicos, os profissionais de saúde têm acesso
            a uma nova aba chamada Sistemas externos.
          </NewsListItem>
          <NewsListItem>
            A aba Sistemas externos só fica visível no atendimento se houver algum sistema previamente configurado pelo
            administrador da instalação.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-5_sistemas_externos.gif'
            pausedSrc='/static/novidades/5-5_sistemas_externos.png'
            alt='Gif mostrando o sistema externo "Manual e-SUS APS" aberto pelo menu principal e pela aba Sistemas externos durante um atendimento individual.'
            width={1275}
            height={894}
          />
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_SDC_RISCO_CARDIOVASCULAR_ENABLED && (
        <NewsHeadingSection
          title='Suporte à Decisão Clínica - Alerta de Risco Cardiovascular'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='sdc-alerta-risco-cardiovascular-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              O Suporte à Decisão Clínica conta com um novo fluxo para todos os cidadãos com idade entre {'>'}= 40 anos
              e {'<'} 75 anos. Nesse caso, o SDC utiliza todos os registros de CIAP-2 ou CID-10 na seção de
              problemas/condições para decidir se dispara alerta de "Risco cardiovascular Muito Alto identificado" ou
              "Risco cardiovascular Alto identificado".
            </NewsParagraph>
            <NewsParagraph>
              Para o "Risco cardiovascular Muito Alto identificado" ao menos um dos CID-10 e CIAP-2 está presente com
              qualquer situação:
            </NewsParagraph>
            <Table style={{ tableLayout: 'fixed', width: '100%' }}>
              <TableBody>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Doença Cardiovascular</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CIAP-2: </Text> K74, K75, K76, K77, K87, K89, K90, K91, K92 ou K99
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Doença Cardiovascular</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CID-10: </Text>
                    <ExpandableText texto={listaCidsCardiovascular} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <NewsParagraph>
              Para o "Risco cardiovascular Alto identificado" ao menos um dos CID-10 e CIAP-2 está presente com qualquer
              situação:
            </NewsParagraph>
            <Table style={{ tableLayout: 'fixed', width: '100%' }}>
              <TableBody>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Diabetes Mellitus</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CIAP-2: </Text> T89, T90
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Diabetes Mellitus</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CID-10: </Text>
                    <ExpandableText texto={listaCidsDiabetesMellitus} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Doença Renal Crônica</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CID-10: </Text> N18, N18.0, N18.8, N18.9 ou N19
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <NewsParagraph>
              Caso algum risco cardiovascular seja detectado, o sistema exibe o card "Rastreamentos" na lateral do
              atendimento:
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_card_rastreamento_risco_cardiovascular_alto.webp'
                alt='Card de rastreamento para risco cardiovascular alto'
                width={363}
                height={139}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_card_rastreamento_risco_cardiovascular_muito_alto.webp'
                alt='Card de rastreamento para risco cardiovascular muito alto'
                width={365}
                height={138}
              />
            </Carousel>
            <NewsParagraph>
              Quando um profissional de saúde registra alguns dos CID-10 ou CIAP-2 o sistema dispara o alerta
              correspondente: "Conduta recomendada para Risco Cardiovascular - Risco Alto" ou "Conduta recomendada para
              Risco Cardiovascular - Risco Muito Alto".
            </NewsParagraph>
            <NewsParagraph>Textos de Conduta recomendada para Risco Cardiovascular - Risco Alto:</NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_alto_parte_1.webp'
                alt='Primeira parte do texto de conduta recomendada para risco alto'
                width={905}
                height={723}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_alto_parte_2.webp'
                alt='Segunda parte do texto de conduta recomendada para risco alto'
                width={905}
                height={725}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_alto_parte_3.webp'
                alt='Terceira parte do texto de conduta recomendada para risco alto'
                width={906}
                height={727}
              />
            </Carousel>
            <NewsParagraph>Textos de Conduta recomendada para Risco Cardiovascular - Risco Muito Alto:</NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_1.webp'
                alt='Primeira parte do texto de conduta recomendada para risco muito alto'
                width={907}
                height={724}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_2.webp'
                alt='Segunda parte do texto de conduta recomendada para risco muito alto'
                width={906}
                height={726}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_3.webp'
                alt='Terceira parte do texto de conduta recomendada para risco muito alto'
                width={907}
                height={725}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_4.webp'
                alt='Quarta parte do texto de conduta recomendada para risco muito alto'
                width={907}
                height={726}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_SDC_PRE_ECLAMPSIA_ENABLED && (
        <NewsHeadingSection
          title='Suporte à Decisão Clínica - Alerta de Risco de Pré-Eclâmpsia'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='sdc-alerta-risco-pre-eclampsia-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              O Suporte à Decisão Clínica dispara os seguintes alertas de risco de Pré-Eclâmpsia: "Gestante com risco de
              pré-eclâmpsia identificado" e "Conduta recomendada para risco de pré-eclâmpsia" sempre que há uma gravidez
              ativa no prontuário da cidadã atendida e pelo menos uma das condições abaixo é identificada.
            </NewsParagraph>
            <NewsList>
              <NewsListItem>
                O usuário registra no atendimento atual ou o prontuário possui registro na Lista de Problemas ou
                Condições (LPC), com qualquer situação ("Ativa", "Latente" ou "Resolvida"), de algum dos seguintes
                problemas/condições (CID-10 ou CIAP-2): Diabetes Mellitus, Hipertensão, Gestação Múltipla, Obesidade,
                Doença Renal, Lúpus Eritematoso Sistêmico, Síndrome de Anticorpo Antifosfolípide, Doença Falciforme ou
                Fertilização In Vitro;
              </NewsListItem>
              <NewsListItem>O tipo de gravidez é "Dupla/gemelar" ou "Tripla ou mais";</NewsListItem>
              <NewsListItem>
                O prontuário possui registro de IMC pré-gestacional maior ou igual a 30 (sendo considerado o valor mais
                próximo da DUM, até 2 meses antes ou até 8 semanas de IG cronológica);
              </NewsListItem>
              <NewsListItem>
                O prontuário possui registro na LPC com situação "Resolvida" de algum dos seguintes problemas/condições
                (CID-10 ou CIAP-2): Pré-eclâmpsia, Eclâmpsia ou HELLP.
              </NewsListItem>
            </NewsList>
            <NewsParagraph>
              <Text fontWeight='bold' component='strong'>
                IMPORTANTE:{' '}
              </Text>
              Os alertas de Risco de Pré-Eclâmpsia não são disparados caso o usuário registre no atendimento atual ou o
              prontuário possua registro na LPC com a situação "Ativa" ou "Latente" de Pré-eclâmpsia, Eclâmpsia ou
              HELLP.
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_alerta_gestante_com_risco_de_pre-eclampsia_identificado.webp'
                alt='Modal do Suporte à Decisão Clínica exibindo alerta de Gestante com risco de pré-eclâmpsia identificado, com explicação sobre a análise feita pelo sistema e seções para fatores verificados ou não automaticamente.'
                width={2088}
                height={1572}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_alerta_conteudo_accordions_fatores_identificados_ou_nao_automaticamento_pelo_sistema.webp'
                alt='Conteúdo do modal do Suporte à Decisão Clínica exibindo alerta de Gestante com risco de pré-eclâmpsia identificado, com explicação sobre a análise feita pelo sistema e detalhamento do motivo do risco de pré-eclâmpsia identificado, apresentando dois grupos de fatores: os verificados automaticamente pelo sistema, listados em tabela com fonte das informações, e os não verificados automaticamente, mostrados em lista de itens.'
                width={1548}
                height={3801}
                preserveAspectRatio
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_alerta_conduta_recomendada_para_risco_de_pre_eclampsia.webp'
                alt='Modal do Suporte à Decisão Clínica exibindo alerta de Conduta recomendada para risco de pré-eclâmpsia, listando medicamentos sugeridos e orientações à gestante.'
                width={1920}
                height={1328}
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_conteudo_alerta_conduta_recomendada_para_risco_de_pre_eclampsia.webp'
                alt='Conteúdo do modal do Suporte à Decisão Clínica exibindo alerta de Conduta recomendada para risco de pré-eclâmpsia, com a recomendação de uso de ácido acetilsalicílico, orientações de atividade física e alimentação saudável e sinais de alerta para buscar atendimento. No final constam as referências da conduta recomendada.'
                width={1548}
                height={2937}
                preserveAspectRatio
              />
            </Carousel>
            <NewsParagraph>
              Além disso, o status do risco de pré-eclâmpsia é exibido no card de pré-natal (na lateral do atendimento)
              e nos campos de pré-natal. O status é exibido como "Não identificado" por padrão, mas muda para
              "Identificado" caso o sistema identifique alguma condição de risco.
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_status_risco_pre_eclampsia_atendimento_pre_natal.webp'
                alt='Imagem com destaque para o risco de pré-eclâmpsia identificado em um atendimento, exibido no card lateral de pré-natal e também na seção do Suporte à Decisão Clínica no final do formulário Pré-natal, parto e nascimento.'
                width={1651}
                height={768}
              />
              <CarouselItem
                image='/static/novidades/5-5_status_risco_pre_eclampsia_card_pre_natal.webp'
                alt='No card de informações do Pré-natal, há um campo com o texto "Risco de pré-eclâmpsia:" seguido por um selo vermelho com a palavra "Identificado", indicando que o risco foi detectado pelo sistema.'
                width={512}
                height={723}
              />
              <CarouselItem
                image='/static/novidades/5-5_status_risco_pre_eclampsia_campo_pre_natal.webp'
                alt='No final do formulário Pré-natal, parto e nascimento, há uma seção do Suporte à Decisão Clínica. Ela informa que o sistema analisa os dados do prontuário para identificar riscos. O texto mostra que foi identificado risco de pré-eclâmpsia, com um selo em vermelho com a palavra "Identificado". Há também uma observação indicando que o risco foi atualizado pelo SDC em uma data (não preenchida na imagem)'
                width={1156}
                height={587}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Evolução na vinculação de cidadãos e famílias'
        icon={<AcompanhamentoCondicoesDeSaudeIcon css={styles.iconSVG} />}
        id='vinculacao-cidadao-formacao-familias-5-5'
      >
        <NewsSectionContent>
          <NewsListItem>
            Na versão 5.5 do Prontuário Eletrônico e-SUS APS, a vinculação ficou mais simples e organizada. Agora, cada
            cidadão passa a estar vinculado apenas a uma equipe, unidade e família por vez, sempre respeitando a
            atualização mais recente do seu cadastro.
          </NewsListItem>

          <NewsListItem>
            Além disso, no prontuário e-SUS APS, todos os cidadãos que estavam vinculados a múltiplas equipes ou
            famílias foram automaticamente ajustados para apenas um território e uma família, conforme o último Cadastro
            Individual atualizado.
          </NewsListItem>

          <NewsListItem>
            Com essa melhoria, os relatórios consolidados passam a refletir o mesmo conjunto de cidadãos do
            Acompanhamento de Cidadãos Vinculados.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_M_CHAT_RF_ENABLED && (
        <NewsHeadingSection
          title='Avaliação do M-CHAT-R/F™ completo com Entrevista de Seguimento na puericultura'
          icon={<img src={PuericulturaIcon} alt='Puericultura' css={css(styles.iconSVG, styles.fillableIconSVG)} />}
          id='avaliacao-M-CHAT-RF-completo-entrevista-seguimento-puericultura-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              No atendimento de <strong>Puericultura para crianças de 16 a 30 meses,</strong> agora é possível aplicar o{' '}
              <strong>
                M-CHAT-R/F™ (Checklist Modificado para Autismo em Crianças Pequenas) de forma completa diretamente no
                sistema.
              </strong>{' '}
              Trata-se de um instrumento de triagem amplamente utilizado para identificar sinais precoces do Transtorno
              do Espectro Autista (TEA).
            </NewsParagraph>
            <NewsParagraph>
              Com essa atualização, os profissionais de saúde podem aplicar, registrar e analisar os resultados do
              M-CHAT-R/F sem sair do sistema. Quando o resultado indicar necessidade de investigação, o profissional
              também pode preencher a <strong>Entrevista de Seguimento</strong> diretamente na plataforma, facilitando o
              encaminhamento para diagnóstico.
            </NewsParagraph>
            <NewsGif
              src='/static/novidades/5-5_m_chat_rf_puericultura.webm'
              pausedSrc='/static/novidades/5-5_m_chat_rf_puericultura.webp'
              alt='Gif mostrando o acesso até o M-CHAT-R através da puericultura, e o preenchimento do instrumento.'
              width={1152}
              height={648}
            />
            <NewsListItem>
              Após o registro de uma <strong>avaliação do M-CHAT-R/F™,</strong> é possível visualizar os resultados
              através do modal de <strong>Acompanhamento da criança,</strong> ou selecionando a opção{' '}
              <strong>Histórico de resultados</strong> na seção do M-CHAT-R/F™.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_m_chat_rf_historico_resultado.webm'
              pausedSrc='/static/novidades/5-5_m_chat_rf_historico_resultado.webp'
              alt='Gif mostrando o histórico de resultados'
              width={1236}
              height={627}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
        <NewsHeadingSection
          title='Regulação assistencial'
          icon={<GarantiaAcessoIcon css={styles.iconSVG} />}
          id='regulacao-assistencial-5-5'
        >
          <NewsSectionContent>
            <NewsListItem>
              Agora no módulo da <strong>Garantia de Acesso</strong>, é apresentada a possibilidade de consultar a aba
              de <strong>Regulação Assistencial</strong>. Nessa seção, os profissionais podem acompanhar as solicitações
              de Exames e Guias de Encaminhamento geradas nos atendimentos que passam pelo processo de regulação
              assistencial. O PEC recebe atualizações de status para essas solicitações através de uma integração com os
              sistemas de regulação próprios configurados pelo administrador da instalação.
            </NewsListItem>
            <NewsListItem>
              As solicitações podem ser filtradas por{' '}
              <strong>Unidade e Equipe Responsável, Tipo de Solicitação e Status</strong>. Além de ser possível filtrar
              pelo profissional solicitante e o período de realização da solicitação.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_selecao_e_pesquisa_RA.webp'
              pausedSrc='/static/novidades/5-4_selecao_e_pesquisa_RA_paused.webp'
              alt='Gif mostrando a abertura da aba de Garantia de acesso e seleção da regulação assistencial'
              width={800}
              height={400}
            />
            <NewsListItem>
              Todos os profissionais com acesso aos atendimentos que podem solicitar Exames e Guia de Encaminhamento,
              têm acesso à aba da <strong>Regulação Assistencial</strong>, dentro do módulo de{' '}
              <strong>Garantia de Acesso</strong>.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_filtro_RA.webp'
              pausedSrc='/static/novidades/5-4_filtro_RA_paused.webp'
              alt='Gif mostrando a aba da regulação assistencial e a utilização do filtro secundário de "Solicitante"'
              width={800}
              height={401}
            />
            <NewsListItem>
              Ao visualizar um registro de solicitação, é possível ver o seu <strong>histórico de atualizações</strong>{' '}
              para entender como está o processo de regulação assistencial daquele registro no sistema de regulação.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_modal_RA.webp'
              pausedSrc='/static/novidades/5-4_modal_RA_paused.webp'
              alt='Gif mostrando a modal de visualização da regulação, com o histórico de atualizações do registro sendo expandido'
              width={1186}
              height={702}
            />
            <NewsParagraph>
              Além disso, o módulo de Regulação assistencial conta com notificações visuais no menu lateral e na
              listagem de solicitações, mantendo os profissionais informados sobre alterações importantes nos
              encaminhamentos, exames e OCIs.
            </NewsParagraph>
            <NewsListItem>
              Sinalização Visual: Sempre que uma solicitação é atualizada para os status "Devolvido pela regulação",
              "Atendimento agendado" ou "Negada pela regulação", o profissional solicitante é notificado com um contador
              no menu lateral e um ícone de leitura destacado na linha correspondente da listagem.
            </NewsListItem>
            <NewsListItem>
              Filtro de Notificações: Ao ativar o filtro "Ver somente solicitações com notificação", a lista exibe
              apenas os itens que possuem uma notificação pendente. Um contador ao lado do filtro mostra o número total
              de solicitações não lidas.
            </NewsListItem>
            <NewsParagraph>Atualização de uma solicitação para os status:</NewsParagraph>
            <NewsListItem>Devolvido pela regulação;</NewsListItem>
            <NewsListItem>Atendimento agendado;</NewsListItem>
            <NewsListItem>Negada pela regulação.</NewsListItem>
            <NewsParagraph>
              O que encerra a notificação:
              <NewsList>
                <NewsListItem>No menu lateral:</NewsListItem>
                <NewsList>
                  <NewsListItem>Ao acessar o módulo com notificações pendentes.</NewsListItem>
                </NewsList>
                <NewsListItem>Dentro do módulo:</NewsListItem>
                <NewsList>
                  <NewsListItem>Quando o profissional solicitante clica para visualizar a solicitação.</NewsListItem>
                  <NewsListItem>
                    Quando o status da solicitação é alterado para qualquer outro diferente de "Devolvido pela
                    regulação", "Atendimento agendado" ou "Negada pela regulação".
                  </NewsListItem>
                </NewsList>
              </NewsList>
            </NewsParagraph>
            <NewsParagraph>Veja como é exibido:</NewsParagraph>
            <NewsImg
              src='/static/novidades/5-4_notificacao_regulacao_menu_lateral.webp'
              alt='Imagem exibindo as notificações de Regulação assistencial no menu lateral'
              width={394}
              height={207}
            />
            <NewsImg
              src='/static/novidades/5-4_notificacao_regulacao_lista.webp'
              alt='Imagem exibindo as notificações de Regulação assistencial na listagem'
              width={1344}
              height={664}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Renovar prescrição de uso contínuo'
        icon={<Consulta css={styles.iconSVG} />}
        id='renovar-prescricao-5-5'
      >
        <NewsSectionContent>
          <NewsListItem>
            Atualmente, tratamentos com medicamentos de uso contínuo que possuem várias prescrições acabam sendo
            apresentados de forma duplicada no prontuário do cidadão.
          </NewsListItem>
          <NewsListItem>
            Para melhorar esse fluxo, foi incluída a ação de "Renovar prescrição", disponível apenas para medicamentos
            de uso contínuo. Diferente da ação de "Replicar prescrição", o fluxo de "Renovar prescrição" agrupa todas as
            prescrições relacionadas em um único tratamento.
          </NewsListItem>
          <NewsListItem>
            Ela pode ser utilizada através do histórico de prescrições ou acessando os "Medicamentos em uso" do cidadão.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-5_renovar-prescricao.webm'
            pausedSrc='/static/novidades/5-5_renovar-prescricao.webp'
            alt='Gif mostrando como renovar uma prescrição de medicamento de uso contínuo.'
            width={2188}
            height={1900}
          />
          <NewsListItem>
            Ao renovar uma prescrição para um medicamento de uso contínuo, a nova prescrição é agrupada com as
            anteriores do mesmo tratamento. É possível visualizar a evolução de prescrições de um tratamento nos
            "Medicamentos em uso" do cidadão.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-5_visualizar-renovacao-prescricao.webm'
            pausedSrc='/static/novidades/5-5_visualizar-renovacao-prescricao.webp'
            alt='Gif mostrando prescrição de medicamento de uso contínuo renovada.'
            width={2188}
            height={1875}
          />
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_GRAFICOS_PRE_TERMO_ENABLED && (
        <NewsHeadingSection
          title='Adaptação dos gráficos de medições para crianças Pré-termo'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='graficos-pre-termo-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              Agora o PEC e-SUS APS identifica crianças nascidas pré-termo e aplica a correção de idade nas
              visualizações de crescimento nos gráficos de medições, utilizando os parâmetros do INTERGROWTH-21.
            </NewsParagraph>
            <NewsParagraph>
              Os gráficos de peso, altura e perímetro cefálico exibem as curvas para prematuros e mostram a idade
              cronológica por semanas.
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_grafico_peso_pre_termo.webp'
                alt='Conteúdo do Gráfico de peso apresentado por semanas para bebês na faixa etária pré-termo, indicando faixa de peso Adequado (verde) e Risco (vermelho) acima e abaixo da linha de referência do gráfico. O gráfico mostra o peso em kg (no eixo vertical) e as semanas (no eixo horizontal), com uma linha azul de tendência de crescimento e a exibição dos dados de Peso, Idade cronológica e Data.'
                width={868}
                height={599}
              />
              <CarouselItem
                image='/static/novidades/5-5_grafico_altura_pre_termo.webp'
                alt='Conteúdo do Gráfico de altura apresentado por semanas para bebês na faixa etária pré-termo, indicando faixa de medida Adequado (verde) e Risco (vermelho) acima e abaixo da linha de referência do gráfico. O gráfico mostra o comprimento em cm (no eixo vertical) e as semanas (no eixo horizontal), com uma linha azul de tendência de crescimento e a exibição dos dados de Comprimento, Idade cronológica e Data.'
                width={864}
                height={601}
              />
              <CarouselItem
                image='/static/novidades/5-5_grafico_perimetro_cefalico_pre_termo.webp'
                alt='Conteúdo do Gráfico de perímetro cefálico apresentado por semanas para bebês na faixa etária pré-termo, indicando faixa de medida Adequado (verde) e Risco (vermelho) acima e abaixo da linha de referência do gráfico. O gráfico mostra o perímetro cefálico em cm (no eixo vertical) e as semanas (no eixo horizontal), com uma linha azul de tendência de crescimento e a exibição dos dados de Perímetro cefálico, Idade cronológica e Data.'
                width={866}
                height={580}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_GRUPOS_ATIVIDADE_COLETIVA_ENABLED && (
        <NewsHeadingSection
          title='Criação e gestão de grupos de atividade coletiva'
          icon={<AtividadeColetivaIcon css={css(styles.iconSVG, styles.fillableIconSVG)} />}
          id='gestao-grupo-atividade-coletiva-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              O módulo de Atividade coletiva passa a contar com a funcionalidade de Gestão de Grupos. Por meio desse
              novo item no menu lateral, é possível criar e gerenciar listas de participantes, incluindo cidadãos e
              profissionais, para organizar os grupos de atividades coletivas da unidade de saúde.
            </NewsParagraph>
            <NewsParagraph>Os grupos podem ser de dois tipos:</NewsParagraph>
            <NewsList>
              <NewsListItem>
                <strong>Atividade em saúde:</strong> permite incluir cidadãos participantes e profissionais envolvidos;
              </NewsListItem>
              <NewsListItem>
                <strong>Reunião:</strong> composto apenas por profissionais.
              </NewsListItem>
            </NewsList>
            <NewsParagraph>Após a criação os grupos podem ser:</NewsParagraph>
            <NewsList>
              <NewsListItem>
                <strong>atualizados</strong>, com inclusão ou remoção de participantes;
              </NewsListItem>
              <NewsListItem>
                <strong>inativados</strong>, quando pausados temporariamente;
              </NewsListItem>
              <NewsListItem>
                <strong>excluídos</strong>, quando descontinuados.
              </NewsListItem>
            </NewsList>
            <NewsParagraph>
              Todos os grupos criados ficam disponíveis em uma tabela com as seguintes opções de filtro para facilitar a
              gestão:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>Unidade de saúde;</NewsListItem>
              <NewsListItem>Equipes envolvidas;</NewsListItem>
              <NewsListItem>Tipo de grupo;</NewsListItem>
              <NewsListItem>Visualizar apenas grupos inativos;</NewsListItem>
              <NewsListItem>Visualizar apenas grupos dos quais você participa;</NewsListItem>
              <NewsListItem>Campo de busca por nome do grupo.</NewsListItem>
            </NewsList>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_1.webp'
                alt='Imagem exibindo acesso ao módulo de Gestão de grupos de atividade coletiva'
                width={1167}
                height={639}
              />
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_2.webp'
                alt='Imagem exibindo listagem do módulo de Gestão de grupos de atividade coletiva'
                width={1167}
                height={639}
              />
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_3.webp'
                alt='Imagem exibindo filtros do módulo de Gestão de grupos de atividade coletiva'
                width={1167}
                height={639}
              />
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_4.webp'
                alt='Imagem exibindo cadastro do módulo de Gestão de grupos de atividade coletiva'
                width={1167}
                height={639}
              />
            </Carousel>
            <NewsParagraph>
              Além disso, é possível utilizar um grupo previamente cadastrado durante o registro de uma atividade
              coletiva. Ao selecionar o grupo em registros de Atividade em saúde ou em Reunião, os participantes
              (cidadãos e profissionais) são automaticamente carregados nas tabelas do registro.
            </NewsParagraph>
            <NewsGif
              src='/static/novidades/5-5_cadastro_gestao_grupos_atividade_coletiva.webp'
              pausedSrc='/static/novidades/5-5_cadastro_gestao_grupos_atividade_coletiva-paused.webp'
              alt='Gif mostrando cadastro de grupos de atividade coletiva'
              width={800}
              height={644}
            />
            <NewsParagraph>
              Com essa funcionalidade, torna-se mais simples gerenciar grupos fixos e recorrentes da unidade, além de
              agilizar o registro das atividades coletivas, evitando a necessidade de adicionar manualmente os mesmos
              participantes a cada novo registro.
            </NewsParagraph>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {MOTIVO_PRESCRICAO_ENABLED && (
        <NewsHeadingSection
          title='Inclusão do campo Motivo da prescrição'
          id='motivo-prescricao-5-5'
          icon={<Consulta />}
        >
          <NewsSectionContent>
            <NewsListItem>
              Foi incluído um novo campo obrigatório na prescrição de medicamentos, o "Motivo da prescrição". Nele, é
              preciso informar um CID-10 ou um CIAP-2 associado ao medicamento sendo prescrito.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_motivo_prescricao.webm'
              pausedSrc='/static/novidades/5-5_motivo_prescricao_paused.webp'
              alt='Gif mostrando o novo campo Motivo da prescrição'
              width={1600}
              height={787}
            />
            <NewsListItem>
              É possível visualizar o motivo da prescrição de um medicamento também na Folha de rosto, no Histórico e na
              impressão de atendimento.
            </NewsListItem>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_VINCULACAO_CUIDADO_ENABLED && (
        <NewsHeadingSection
          title='Melhorias em Encaminhamento e Cuidado compartilhado'
          id='melhorias-encaminhamento-e-cc-5-5'
          icon={<GarantiaAcessoIcon css={styles.iconSVG} />}
        >
          <NewsParagraph>
            Os módulos de Cuidado compartilhado e Encaminhamento foram aprimorados
            {PILOTO_VINCULACAO_CUIDADO_ODONTO_ENABLED ? '' : ' para os atendimentos individuais'}. Agora, estão
            unificados na nova aba Encaminhamento/Compartilhamento de cuidado. Confira as principais novidades:
          </NewsParagraph>
          <NewsList>
            <VFlow vSpacing={0.5}>
              <NewsListItem>
                A nova aba Encaminhamento/Compartilhamento de cuidado concentra tanto a geração de guias de
                encaminhamento quanto o compartilhamento de cuidados, substituindo a antiga aba Encaminhamentos. A
                partir de agora, todas as guias são geradas por essa nova aba, utilizando CBO, Especialidade e
                Classificação de prioridade. O histórico anterior permanece acessível para consulta de encaminhamentos
                antigos, por meio do Histórico anterior à unificação.
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_nova_aba_guia_encaminhamento_especialidade.webp'
                alt='Imagem exibindo a guia de encaminhamento'
                width={1666}
                height={1346}
                style={{ marginTop: 8, marginBottom: 8 }}
              />
              <NewsListItem>
                A impressão das guias de encaminhamento foi atualizada para incluir informações importantes, como
                endereço, CPF e CNS do cidadão. Além disso, a quantidade de caracteres permitida no campo de texto foi
                ampliada para até 2000 caracteres.
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_impressao_guia_encaminhamento_especialidade.webp'
                alt='Imagem exibindo impressão da guia de encaminhamento'
                width={1190}
                height={1684}
                style={{ marginTop: 8, marginBottom: 8 }}
              />
              <NewsListItem>
                Agora é possível compartilhar cuidados entre estabelecimentos da Atenção Primária e serviços
                especializados de referência, facilitando a integração do cuidado entre os diferentes níveis de atenção.
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_compartilhamento_cuidado_entre_estabelecimentos.webp'
                alt='Imagem exibindo o compartilhamento de cuidado entre estabelecimentos da Atenção Primária e serviços especializados'
                width={1151}
                height={849}
                style={{ marginTop: 8, marginBottom: 16 }}
              />
              <VFlow vSpacing={0.5}>
                <NewsListItem>
                  O sistema também permite aos profissionais eMulti compartilhar cuidados com:
                </NewsListItem>
                <NewsList>
                  <NewsListItem>Profissionais eMulti de sua equipe;</NewsListItem>
                  <NewsListItem>Profissionais das equipes vinculadas.</NewsListItem>
                </NewsList>
              </VFlow>
              <NewsListItem>
                O módulo de Cuidado compartilhado também passa a considerar, na criação dos registros, os períodos de
                ausência dos profissionais (como férias, licenças, atestados ou cursos) registrados na "Configuração de
                fechamentos da agenda".
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-5_compartilhamento_cuidado_fechamento_agenda.webp'
                width={1159}
                height={1015}
                alt='Imagem exibindo um profissional com agenda fechada no compartilhamento de cuidado'
                style={{ marginTop: 8, marginBottom: 8 }}
              />
              <NewsParagraph>
                Essa melhoria tem como objetivo evitar que um cuidado seja compartilhado para um profissional que não
                está disponível no momento.
              </NewsParagraph>
            </VFlow>
          </NewsList>
        </NewsHeadingSection>
      )}
      {PILOTO_EXAMES_SAUDE_MULHER_ENABLED && (
        <NewsHeadingSection
          title='PDFs para solicitar exames de mamografia e citopatológico de colo uterino'
          icon={<Icon icon='fileWithItemsOutline' css={css(styles.iconSVG, styles.fillableBlueIconSVG)} />}
          id='pdfs-solicitar-exames-saude-mulher-5-5'
        >
          <NewsSectionContent>
            <NewsListItem>
              Com objetivo de promover, fortalecer e acompanhar ações relacionadas à saúde da mulher, o PEC conta com
              novos PDFs de <strong>solicitações de exames para mamografia e citopatológico de colo uterino</strong> que
              seguem o padrão do <strong>Sistema de Informação do Câncer - SISCAN</strong>. Desta forma, as informações
              podem ser integradas ao SISCAN de forma mais fácil e ágil, facilitando a rotina do profissional de saúde.
            </NewsListItem>
            <NewsListItem>
              Os PDFs estão disponíveis para impressão e preenchimento de acordo com os exames registrados no
              {' SOAP > Plano > Solicitação de exames/procedimentos.'}
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-5_plano_req_citopatologico.webp'
              alt='Imagem exibindo a opção de impressão da requisição de citopatológico de colo uterino'
              width={811}
              height={499}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Possibilidade de escolha da idade gestacional'
        icon={<Icon icon='pregnant' css={[styles.iconSVG, styles.fillableIconSVG]} />}
        id='possibilidade-escolha-idade-gestacional-5-5'
      >
        <NewsSectionContent>
          <NewsListItem>
            Foi incluída a possibilidade de definir qual idade gestacional é utilizada para fins de acompanhamento
            durante a gestação no sistema. É possível escolher entre a DUM e a ecografia. Quando escolhida a ecografia,
            é considerado o primeiro exame realizado após a DUM.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-5_possibilidade_escolha_ig.webp'
            pausedSrc='/static/novidades/5-5_possibilidade_escolha_ig_paused.webp'
            alt='Gif mostrando a possibilidade de escolha da idade gestacional'
            width={800}
            height={398}
          />
          <NewsListItem>
            Nos gráficos de medições, acompanhamento de pré-natal e acompanhamento de condições de saúde, o início da
            gestação para fins de cálculo passa a ser definido com base na escolha do profissional.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_PRONTUARIO_FAMILIAR_ENABLED && (
        <NewsHeadingSection title='Prontuário Familiar' id='prontuario-familiar-5-5' icon={<CidadaoIcon />}>
          <NewsSectionContent>
            <NewsListItem>
              A nova aba <b>Prontuário Familiar</b> no cadastro do cidadão reúne, em um só lugar, informações
              importantes sobre a família de um cidadão. Com ela, fica mais simples ter uma visão completa sobre cada
              cidadão e sua família.
            </NewsListItem>
            <NewsListItem>
              Diretamente no cadastro do cidadão e em um só lugar, são apresentadas informações como dados cadastrais da
              família, identificação dos familiares e acesso aos seus cadastros ou prontuários (conforme as permissões
              do usuário), além de detalhes sobre as condições de moradia.
            </NewsListItem>
            <NewsListItem>
              Também estão disponíveis indicadores importantes, como o Risco de Insegurança Alimentar e indicação de
              recebimento do Bolsa Família, quando é o caso, bem como o histórico das últimas visitas realizadas à
              família.
            </NewsListItem>
            <NewsListItem>
              Todo esse conteúdo pode ser consultado tanto durante o atendimento quanto ao acessar apenas o cadastro.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_prontuario_familiar.webm'
              pausedSrc='/static/novidades/5-5_prontuario_familiar_paused.webp'
              alt='Gif mostrando o novo Prontuário Familiar'
              width={1582}
              height={885}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED && (
        <NewsHeadingSection
          title='Relatório gerencial de cadastro individual'
          id='relatorio-gerencial-cadastro-individual-5-5'
          icon={<Relatorios />}
        >
          <NewsSectionContent>
            <NewsListItem>
              Novo <strong>Relatório Gerencial de Cadastro Individual</strong>. Estamos disponibilizando um novo
              relatório gerencial que permite uma análise detalhada dos cadastros individuais. Este recurso foi
              desenvolvido para oferecer maior visibilidade e facilitar o acompanhamento de informações relacionadas ao
              cadastro individual.
            </NewsListItem>
            <NewsListItem>
              Diferente dos demais relatórios gerenciais, o <strong>Relatório Gerencial de Cadastro Individual</strong>{' '}
              exibe sempre o <strong>último registro atualizado</strong> vinculado à equipe de acompanhamento. Por se
              tratar de um panorama em tempo real da situação do cidadão, este relatório não utiliza filtros de período,
              garantindo que você visualize o dado mais recente disponível.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_uso_relatorio_cadastro.webm'
              pausedSrc='/static/novidades/5-5_uso_relatorio_cadastro_paused.webp'
              alt='Gif mostrando o uso do relatório e geração da tabela'
              width={806}
              height={480}
            />
            <NewsListItem>
              O relatório introduz o campo <strong>"Agrupar por"</strong>, que altera a visualização de dados com
              múltipla seleção:
            </NewsListItem>
            <NewsList>
              <NewsListItem>
                <strong>Pessoas:</strong> Agrupa as informações para garantir que cada cidadão seja contabilizado apenas
                uma vez.
              </NewsListItem>
              <NewsListItem>
                <strong>Registros:</strong> Lista cada opção selecionada de forma independente. Nesta visão, o
                totalizador é ocultado para evitar duplicidade na contagem real de cidadãos.
              </NewsListItem>
            </NewsList>
            <NewsGif
              src='/static/novidades/5-5_agrupar_por_relatorio.webm'
              pausedSrc='/static/novidades/5-5_agrupar_por_relatorio_paused.webp'
              alt='Gif mostrando a funcionalidade Agrupar Por'
              width={808}
              height={482}
            />
            <NewsListItem>
              <strong>Exportação de dados:</strong> Permite a exportação dos resultados em arquivos CSV, garantindo
              maior flexibilidade no uso e compartilhamento das informações.
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-5_print_csv_gerado.webp'
              width={1811}
              height={699}
              alt='Print do CSV gerado'
              style={{ marginTop: 8 }}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection title='Painel de chamadas' icon={<Icon icon='desktopOutline' />} id='painel-chamadas-5-5'>
        <NewsSectionContent>
          <NewsList>
            <NewsListItem>
              Agora o profissional pode <strong>chamar o paciente para atendimento</strong> em uma unidade de saúde por
              meio de um <strong>Painel de chamadas</strong>.
            </NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-5_painel_chamadas_visao_geral.webm'
            pausedSrc='/static/novidades/5-5_painel_chamadas_visao_geral.webp'
            alt='Tela do painel de chamadas exibindo a sala e o paciente chamado'
            width={1205}
            height={594}
          />
          <NewsList>
            <NewsListItem>
              Ele pode ser utilizado através da opção <strong>"Chamar"</strong> da{' '}
              <strong>Lista de atendimentos</strong>.
            </NewsListItem>
            <NewsListItem>
              Ao chamar um paciente, é necessário confirmar o tipo de atendimento e a sala/consultório para onde ele
              será chamado.
            </NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-5_painel_chamadas_lista_atendimentos.webm'
            pausedSrc='/static/novidades/5-5_painel_chamadas_lista_atendimentos.webp'
            alt='Lista de atendimentos com o botão chamar destacado'
            width={1205}
            height={424}
          />
          <NewsList>
            <NewsListItem>
              Para habilitar a funcionalidade, é necessário que o <strong>coordenador</strong> do estabelecimento de
              saúde <strong>configure ao menos um dispositivo</strong> para utilizar o painel e{' '}
              <strong>cadastre as salas disponíveis</strong> na sua unidade.
            </NewsListItem>
          </NewsList>
        </NewsSectionContent>
      </NewsHeadingSection>
      {PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED && (
        <NewsHeadingSection title='Retificação do atendimento de procedimentos' id='retificacao-procedimentos-5-5'>
          <NewsSectionContent>
            <NewsParagraph>Foi adicionada a funcionalidade de retificar atendimentos de procedimentos.</NewsParagraph>
            <NewsParagraph>
              Através do histórico do cidadão, é possível que a lotação profissional que realizou o atendimento de
              procedimentos retifique o registro por meio de duas funcionalidades: "Editar registro" e "Remover registro
              do prontuário".
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_botao_historico.webp'
                alt='Botão de retificação no histórico de atendimentos'
                width={1783}
                height={845}
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_modal.webp'
                alt='Modal de retificação de atendimentos'
                width={905}
                height={711}
              />
            </Carousel>
            <NewsParagraph>
              Ao escolher a opção "Editar registro" é possível adicionar, editar e remover registros do atendimento de
              procedimentos.
            </NewsParagraph>
            <NewsGif
              src='/static/novidades/5-5_retificacao_procedimentos_edicao.webm'
              pausedSrc='/static/novidades/5-5_retificacao_procedimentos_edicao_capa.webp'
              alt='Animação mostrando a edição de um atendimento de procedimentos'
              width={1856}
              height={928}
            />
            <NewsParagraph>
              As informações dos registros que foram editados ou removidos são enviadas para a base nacional. Além
              disso, os registros editados ou removidos podem ser visualizados na Trilha de Auditoria do PEC e-SUS APS.
              A auditoria dos registros editados e removidos é exibida para o usuário no seguinte formato:
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_auditoria_exclusao.webp'
                alt='Registro de auditoria de exclusão de atendimento'
                width={1484}
                height={106}
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_auditoria_edicao.webp'
                alt='Registro de auditoria de edição de atendimento'
                width={1626}
                height={243}
              />
            </Carousel>
            <NewsParagraph>
              Após a edição ou remoção, o histórico do cidadão e as impressões dos atendimentos são adaptados para
              informar quais registros foram retificados:
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_botao_impressao.webp'
                alt='Botão de impressão de registros inativos'
                width={1575}
                height={379}
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_impressao.webp'
                alt='Impressão de um registro inativo'
                width={577}
                height={689}
              />
            </Carousel>
            <NewsParagraph>
              Para visualizar os registros removidos, é necessário ativar o filtro "Exibir registros removidos" no botão
              "Outros filtros":
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_filtro_removidos.webp'
                alt='Filtro para exibir atendimentos inativos'
                width={666}
                height={306}
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_historico_removido.webp'
                alt='Registro removido no histórico de atendimentos'
                width={1459}
                height={161}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_RNDS_REPM_ENABLED && PILOTO_ASSINADOR_REPM_ENABLED && (
        <NewsHeadingSection
          title='Assinatura digital REPM'
          icon={<SignatureIcon css={styles.iconSVG} />}
          id='assinatura-digital-repm-5-5'
        >
          <NewsSectionContent>
            <NewsListItem>
              A Rede Nacional de Dados em Saúde (RNDS) está em constante evolução e a novidade desta versão é a
              possibilidade de assinar digitalmente o documento de{' '}
              <strong>Registro Eletrônico da Prescrição de Medicamento (REPM)</strong>, através do PEC ao prescrever um
              medicamento referenciado pela OBM.
            </NewsListItem>
            <NewsListItem>
              Ao assinar digitalmente um REPM, ele se torna um registro confiável: assegura-se que o profissional
              prescritor e os dados inseridos são válidos, verdadeiros e verificados. Quando isso acontece, o registro
              fica apto a ser utilizado por outros sistemas informacionais de forma segura.
            </NewsListItem>
            <NewsListItem>
              Para assinar um REPM, é necessário que a instalação esteja com a RNDS configurada corretamente, o
              profissional tenha o número do conselho de classe cadastrado e possua algum serviço de assinatura digital
              vinculado ao seu CPF.
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-5_modal-assinatura-digital-repm.webp'
              alt='Imagem exibindo a modal de assinatura dos documentos REPM'
              width={727}
              height={310}
              style={{ marginTop: 8 }}
            />
            <NewsImg
              src='/static/novidades/5-5_tela-provedores-assinatura-digital.webp'
              alt='Imagem exibindo a modal de assinatura dos documentos REPM'
              width={1282}
              height={1024}
              style={{ marginTop: 8 }}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_INATIVACAO_IMOVEIS_ENABLED && (
        <NewsHeadingSection
          title='Inativação de imóveis'
          icon={<Icon icon='houseFilled' />}
          id='inativacao-imoveis-5-5'
        >
          <NewsSectionContent>
            <NewsListItem>
              Agora é possível inativar cadastros de imóveis duplicados, que não existem mais ou mesmo que foram
              cadastrados equivocadamente. Com essa nova funcionalidade será possível separá-los dos imóveis que devem
              ser realmente acompanhados.
            </NewsListItem>
            <NewsListItem>
              Na nova tela <strong>{'Gestão de cadastros > Inativação de imóveis'}</strong>, ou diretamente na
              atualização dos cadastro dos imóveis, você poderá marcar um imóvel como "Inativo". Imóveis inativados
              deixam de ser exibidos na microárea e na aba "Fora de área", passando para a nova aba "Inativos". Enquanto
              inativos, eles também não serão exibidos no aplicativo e-SUS Território, Reterritorialização, CDS nem
              contabilizados em relatórios. Para desfazer uma inativação, quando necessário, basta atualizar o cadastro
              e desmarcar a opção.
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-5_inativacao-imoveis.gif'
              alt='Gif mostrando a nova funcionalidade de inativação de imóveis no acompanhamento do território'
              width={1700}
              height={900}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED && !SOLICITACAO_EXAME_MAMOGRAFIA_ENABLED && (
        <NewsHeadingSection
          title='Nova solicitação para exame de citopatológico de colo uterino'
          icon={<Icon icon='female' />}
          id='solicitacao-exame-citopatologico-colo-uterino-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              Com objetivo de promover a integração de sistemas de saúde e acompanhar ações relacionadas à saúde da
              mulher, foi incluído no PEC uma nova{' '}
              <strong>solicitação de exames para citopatológico de colo uterino</strong> que segue o padrão do{' '}
              <strong>Sistema de Informação do Câncer - SISCAN</strong>. Desta forma, as informações estarão
              padronizadas e futuramente poderão ser integradas de forma automática, facilitando a rotina do
              profissional de saúde.
            </NewsParagraph>
            <NewsParagraph>
              A nova solicitação do exame de citopatológico de colo uterino está disponível através do SOAP {'>'} Plano{' '}
              {'>'} Solicitação de exames/procedimentos {'>'} menu do card da solicitação inserida para os seguintes
              exames:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>201020033 - COLETA DE MATERIAL DO COLO DE ÚTERO PARA EXAME CITOPATOLÓGICO</NewsListItem>
              <NewsListItem>203010019 - EXAME CITOPATOLÓGICO CERVICO-VAGINAL/MICROFLORA</NewsListItem>
              <NewsListItem>203010086 - EXAME CITOPATOLÓGICO CERVICO VAGINAL/MICROFLORA-RASTREAMENTO</NewsListItem>
              <NewsListItem>
                201020076 - COLETA DE MATERIAL DO COLO DO ÚTERO PARA EXAME MOLECULAR DE DETECÇÂO DE HPV
              </NewsListItem>
              <NewsListItem>
                201020084 - ENTREGA DE MATERIAL OBTIDO POR AUTO COLETA PARA EXAME MOLECULAR PARA DETECÇÃO DE HPV, NO
                COLO DO ÚTERO
              </NewsListItem>
              <NewsListItem>202100251 - EXAME MOLECULAR DE DETECÇÂO DE HPV</NewsListItem>
            </NewsList>
            <NewsImg
              src='/static/novidades/5-5_citopatologico_colo_uterino.gif'
              alt='Gif mostrando a solicitação para exame citopatológico do colo uterino'
              width={1096}
              height={466}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {SOLICITACAO_EXAME_MAMOGRAFIA_ENABLED && PILOTO_SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED && (
        <NewsHeadingSection
          title='Novas solicitações para exames de citopatológico de colo uterino e mamografia'
          icon={<Icon icon='female' />}
          id='solicitacoes-exame-colo-uterino-mamografia-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              Com objetivo de promover a integração de sistemas de saúde e acompanhar ações relacionadas à saúde
              ginecológica, duas novas solicitações de exames foram incluídas no PEC:{' '}
              <strong>citopatológico de colo uterino</strong> e <strong>mamografia</strong>. Ambas seguem o padrão do{' '}
              <strong>Sistema de Informação do Câncer - SISCAN</strong>. Desta forma, as informações estarão
              padronizadas e futuramente poderão ser integradas de forma automática, facilitando a rotina do
              profissional de saúde.
            </NewsParagraph>
            <NewsParagraph>
              As novas solicitações de exames de citopatológico de colo uterino e mamografia estão disponíveis através
              do SOAP {'>'} Plano {'>'} Solicitação de exames/procedimentos {'>'} menu do card da solicitação inserida.
            </NewsParagraph>
            <NewsParagraph>
              O <strong>citopatológico de colo uterino</strong> está disponível para os seguintes exames/procedimentos:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>201020033 - COLETA DE MATERIAL DO COLO DE ÚTERO PARA EXAME CITOPATOLÓGICO</NewsListItem>
              <NewsListItem>203010019 - EXAME CITOPATOLÓGICO CERVICO-VAGINAL/MICROFLORA</NewsListItem>
              <NewsListItem>203010086 - EXAME CITOPATOLÓGICO CERVICO VAGINAL/MICROFLORA-RASTREAMENTO</NewsListItem>
              <NewsListItem>
                201020076 - COLETA DE MATERIAL DO COLO DO ÚTERO PARA EXAME MOLECULAR DE DETECÇÂO DE HPV
              </NewsListItem>
              <NewsListItem>
                201020084 - ENTREGA DE MATERIAL OBTIDO POR AUTO COLETA PARA EXAME MOLECULAR PARA DETECÇÃO DE HPV, NO
                COLO DO ÚTERO
              </NewsListItem>
              <NewsListItem>202100251 - EXAME MOLECULAR DE DETECÇÂO DE HPV</NewsListItem>
            </NewsList>
            <NewsParagraph>
              A <strong>mamografia</strong> está disponível para os seguintes exames/procedimentos:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>204030030 - MAMOGRAFIA</NewsListItem>
              <NewsListItem>204030188 - MAMOGRAFIA BILATERAL PARA RASTREAMENTO</NewsListItem>
            </NewsList>
            <NewsImg
              src='/static/novidades/5-5_colo_uterino_mamografia.gif'
              alt='Gif mostrando as solicitações para exame citopatológico do colo uterino e mamografia'
              width={1118}
              height={484}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {HORARIO_FINAL_AGENDAMENTO_ENABLED && (
        <NewsHeadingSection
          title='Horário final no agendamento'
          icon={<Icon icon='calendarClockFilled' />}
          id='horario-final-agendamento-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              A partir de agora é possível definir o horário final dos agendamentos, sendo necessário seguir as
              seguintes regras:
            </NewsParagraph>
            <NewsList>
              <NewsListItem>O tamanho máximo do agendamento não pode ultrapassar 1 hora e 30 minutos;</NewsListItem>
              <NewsListItem>
                O tamanho dos agendamentos deve ser um múltiplo da duração dos atendimentos definido pelo administrador
                municipal (exemplo: se a duração é de 20 minutos, podemos ter agendamentos de 40 minutos, 1 hora e 1
                hora e 20 minutos);
              </NewsListItem>
              <NewsListItem>Não é permitido marcar agendamentos com horários de um dia para o outro;</NewsListItem>
              <NewsListItem>Não é permitido realizar agendamentos que ultrapassem turnos;</NewsListItem>
              <NewsListItem>
                Não é permitido registrar agendamentos caso haja outro evento salvo na agenda do profissional durante o
                período do agendamento;
              </NewsListItem>
              <NewsListItem>
                Todos os módulos que permitem realizar agendamentos possuirão o campo "Horário final".
              </NewsListItem>
              <NewsListItem>
                A impressão do agendamento e e-mails dos agendamentos também foram atualizados para possuir o horário
                final.
              </NewsListItem>
            </NewsList>
            <NewsParagraph>Os seguintes módulos foram afetados:</NewsParagraph>
            <NewsList>
              <NewsListItem>Agenda;</NewsListItem>
              <NewsListItem>Garantia de Acesso;</NewsListItem>
              <NewsListItem>Cuidado Compartilhado;</NewsListItem>
              <NewsListItem>
                Agenda presente dentro de todos os atendimentos, incluindo agendamentos de pré-natal;
              </NewsListItem>
              <NewsListItem>Registro tardio;</NewsListItem>
              <NewsListItem>Agenda AD.</NewsListItem>
            </NewsList>
            <NewsParagraph>
              A agenda AD é a única onde o tamanho máximo de um agendamento é de 240 minutos.
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_horario_final_agendamento_consulta.webp'
                alt='Imagem exibindo um agendamento de consulta com horário final'
                width={1568}
                height={1180}
              />
              <CarouselItem
                image='/static/novidades/5-5_horario_final_agendamento_consulta_entre_profissionais.webp'
                alt='Imagem exibindo um agendamento de consulta entre profissionais com horário final'
                width={1568}
                height={1214}
              />
              <CarouselItem
                image='/static/novidades/5-5_horario_final_agendamento_garantia_acesso.webp'
                alt='Imagem exibindo um agendamento no módulo de Garantia de Acesso com horário final'
                width={1494}
                height={1292}
              />
              <CarouselItem
                image='/static/novidades/5-5_horario_final_agendamento_cuidado_compartilhado.webp'
                alt='Imagem exibindo um agendamento no módulo de Cuidado Compartilhado com horário final'
              />
              <CarouselItem
                image='/static/novidades/5-5_horario_final_agendamento_consulta_atendimento.webp'
                alt='Imagem exibindo um agendamento de consulta durante o atendimento com horário final'
                width={1664}
                height={876}
              />
              <CarouselItem
                image='/static/novidades/5-5_horario_final_agendamento_comprovante.webp'
                alt='Imagem exibindo um comprovante de agendamento com horário final'
                width={572}
                height={347}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {HISTORICO_COMPLETO_MCHAT_RF_ENABLED && (
        <NewsHeadingSection
          title='Histórico detalhado da Entrevista de Seguimento M-CHAT-R/F™'
          icon={<img src={PuericulturaIcon} alt='Puericultura' css={css(styles.iconSVG, styles.fillableIconSVG)} />}
          id='mchat-5-5'
        >
          <NewsSectionContent>
            <NewsListItem>
              Agora, no acompanhamento da criança, será possível consultar o{' '}
              <strong>histórico detalhado da Entrevista de Seguimento M-CHAT-R/F™</strong> realizada durante os
              atendimentos de Puericultura. Com essa atualização, os profissionais poderão visualizar de forma mais
              completa e rastreável as entrevistas aplicadas, incluindo a data e hora da aplicação, o profissional
              responsável, a versão do instrumento utilizado e o resultado final da avaliação.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_mchat_1.webm'
              pausedSrc='/static/novidades/5-5_mchat_1_paused.webp'
              alt='GIF mostrando o acesso ao histórico da Entrevista de Seguimento M-CHAT-R/F™ a partir do acompanhamento da criança, exibindo a listagem das entrevistas já aplicadas e as principais informações de cada registro.'
              width={1280}
              height={720}
            />
            <NewsListItem>
              Além das informações gerais da aplicação, também será possível consultar o detalhamento das perguntas e
              respostas preenchidas na entrevista. O sistema apresentará cada item do instrumento, com o número da
              pergunta, a pergunta completa, os exemplos respondidos pelo profissional, o resultado do item como{' '}
              <strong>Passou</strong> ou <strong>Falhou</strong> e, quando houver, as observações ou notas clínicas
              registradas.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_mchat_2.webm'
              pausedSrc='/static/novidades/5-5_mchat_2_paused.webp'
              alt='GIF mostrando a abertura de uma Entrevista de Seguimento M-CHAT-R/F já registrada, exibindo o detalhamento das perguntas, respostas, exemplos preenchidos e resultado de cada item.'
              width={1280}
              height={720}
            />
            <NewsListItem>
              Com o histórico detalhado, o acompanhamento longitudinal do desenvolvimento infantil fica mais
              estruturado, permitindo que os profissionais consultem aplicações anteriores da entrevista e compreendam
              com mais facilidade a evolução dos registros relacionados ao rastreio de sinais de transtorno do espectro
              autista.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_mchat_3.webm'
              pausedSrc='/static/novidades/5-5_mchat_3_paused.webp'
              alt='GIF mostrando a consulta de mais de uma aplicação da Entrevista de Seguimento M-CHAT-R/F no histórico, destacando a visualização dos registros anteriores e o detalhamento de um dos resultados.'
              width={1280}
              height={720}
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {PILOTO_PARTICIPACAO_OBRIGATORIA_TELECONSULTA_ENABLED && (
        <NewsHeadingSection
          title='Interdependência entre o campo forma de participação do cidadão e/ou profissional e o procedimento SIGTAP administrativo de teleconsulta'
          icon={<VideochamadaIcon css={styles.iconSVG} />}
          id='participacao-obrigatoria-teleconsulta-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              Com objetivo de qualificar o registro das informações e garantir maior consistência nos dados de
              atendimentos realizados por teleconsulta, agora torna-se obrigatório o preenchimento do campo{' '}
              <strong>"Forma de participação"</strong> ao selecionar um procedimento SIGTAP administrativo de
              teleconsulta.
            </NewsParagraph>
            <NewsParagraph>
              Essa obrigatoriedade varia conforme o procedimento escolhido, podendo ser aplicada à forma de participação
              do profissional, do cidadão ou de ambos. Caso o campo exigido não seja preenchido, o atendimento não
              poderá ser finalizado, sendo exibido um alerta orientando o profissional de saúde sobre o preenchimento
              necessário.
            </NewsParagraph>
            <NewsParagraph>
              A nova validação da forma de participação está disponível através do SOAP {'>'} Finalização do
              atendimento.
            </NewsParagraph>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_teleconsulta_participacao_cidadao.png'
                alt='Obrigatoriedade de preenchimento da forma de participação do cidadão. Ocorre para determinados procedimentos SIGTAP de teleconsulta que exigem a inclusão da forma de participação do cidadão.'
                width={1820}
                height={864}
              />
              <CarouselItem
                image='/static/novidades/5-5_teleconsulta_participacao_profissional.png'
                alt='Obrigatoriedade de preenchimento da forma de participação do profissional. Ocorre para determinados procedimentos SIGTAP de teleconsulta que exigem a inclusão da forma de participação do profissional.'
                width={1838}
                height={856}
              />
              <CarouselItem
                image='/static/novidades/5-5_teleconsulta_participacao_ambos.png'
                alt='Obrigatoriedade de preenchimento da forma de participação de ambos (cidadão e profissional). Ocorre para determinados procedimentos SIGTAP de teleconsulta que exigem a inclusão da forma de participação de ambos os campos.'
                width={1828}
                height={860}
              />
            </Carousel>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      {ERRATAS_NOTAS_COMPLEMENTARES_ENABLED && (
        <NewsHeadingSection
          title='Registrar errata ou nota complementar ao atendimento'
          id='errata-nota-complementar-5-5'
        >
          <NewsSectionContent>
            <NewsParagraph>
              Com objetivo de incluir informações relevantes ao atendimento que por algum motivo não foram incluídas ou
              mesmo informar a correção de algum dado, foi incluído no PEC a funcionalidade para{' '}
              <strong>Registrar errata ou nota complementar</strong> ao atendimento realizado.
            </NewsParagraph>
            <NewsParagraph>
              O acesso é através do card do <strong>histórico de atendimentos</strong> e somente a lotação que realizou
              o atendimento poderá incluir a errata ou nota complementar.
            </NewsParagraph>
            <NewsParagraph>
              Para encontrar atendimentos com erratas ou notas complementares mais facilmente, basta acessar{' '}
              <strong>Histórico {'>'} Outros filtros </strong>e habilitar a opção{' '}
              <strong>"Exibir somente registros com erratas/notas complementares"</strong>.
            </NewsParagraph>
            <NewsGif
              src='/static/novidades/5_5_criacao_errata_nota_complementar.webm'
              pausedSrc='/static/novidades/5_5_criacao_errata_nota_complementar_paused.webp'
              alt='Gif mostrando o processo de criação de uma Errata/Nota complementar através do historico de atendimento do cidadão.'
            />
            <NewsImg
              src='/static/novidades/5_5_filtro_errata_historico.webp'
              alt='Imagem que mostra o historico de um cidadão e tambem o ícone de inclusão das erratas/notas complementares em um item do historico'
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
    </Fragment>
  )
}

const styles = {
  iconSVG: css`
    margin-right: 0.25rem;
    width: 2rem;
    height: 2rem;
  `,
  fillableIconSVG: css`
    fill: ${gray.c60};
  `,
  fillableBlueIconSVG: css`
    fill: ${blue.c40};
  `,
}
